import { useDrop } from "react-dnd";

const useVerticalResource = ({ handleResourceDropCb, currentResource }) => {
  const [, drop] = useDrop(
    () => ({
      accept: "item-on-event",
      drop: (item) => {
        handleResourceDropCb({ ...currentResource, ...item });
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [handleResourceDropCb]
  );

  return { drop };
};

export default useVerticalResource;
